export const ADMIN_AUTH_STORAGE_KEY = 'firat-celik-kapi-admin-auth-v1';

// Frontend-only auth: credentials are visible in the client bundle.
export const ADMIN_CREDENTIALS = {
  username: 'admin',
  password: '123456',
};

export const getAdminAuthState = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.localStorage.getItem(ADMIN_AUTH_STORAGE_KEY) === '1';
};

export const setAdminAuthState = (isAuthenticated) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (isAuthenticated) {
    window.localStorage.setItem(ADMIN_AUTH_STORAGE_KEY, '1');
    return;
  }

  window.localStorage.removeItem(ADMIN_AUTH_STORAGE_KEY);
};

export const validateAdminCredentials = (username, password) =>
  username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password;
